import React, { Component } from 'react';
import { Container } from '@mui/material';

import { UpcomingErgonarsWidget } from '../../../components';

class UpcomingErgonars extends Component {
  render() {
    return (
      <Container style={{ marginTop: '10px' }}>
        <UpcomingErgonarsWidget height={window.innerHeight - 280} />
      </Container>
    );
  }
}

export default UpcomingErgonars;
